import Axios from "axios";

const base_url = "cp/cities";

export default {
    /**
     * Display a listing of the Cities.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(base_url + "?page=" + page, { params });
    },

    /**
     * Get all cities with specific properties of cities.
     *
     * @returns {Promise}
     */
    getAllShort() {
        return Axios.get(`${base_url}/short`);
    },

    /**
     * Store a new City in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Update the given city in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(base_url + "/" + data.id, data);
    }
};
